/** Formata notas de release para o pop-up (idioma da interface). */

const SECTION_META = {
  'pt-BR': {
    features: ['✨', 'Novidades'],
    improvements: ['🚀', 'Melhorias'],
    fixes: ['🛠️', 'Correções'],
    infra: ['⚙️', 'Plataforma e infraestrutura'],
    other: ['📌', 'Outras atualizações'],
  },
  en: {
    features: ['✨', "What's new"],
    improvements: ['🚀', 'Improvements'],
    fixes: ['🛠️', 'Fixes'],
    infra: ['⚙️', 'Platform & infrastructure'],
    other: ['📌', 'Other updates'],
  },
  es: {
    features: ['✨', 'Novedades'],
    improvements: ['🚀', 'Mejoras'],
    fixes: ['🛠️', 'Correcciones'],
    infra: ['⚙️', 'Plataforma e infraestructura'],
    other: ['📌', 'Otras actualizaciones'],
  },
};

const INTRO = {
  'pt-BR': 'Confira o que mudou nesta versão:',
  en: "Here's what changed in this version:",
  es: 'Consulta lo que cambió en esta versión:',
};

const TOPIC_I18N = {
  notificações: { 'pt-BR': 'Notificações', en: 'Notifications', es: 'Notificaciones' },
  notificacoes: { 'pt-BR': 'Notificações', en: 'Notifications', es: 'Notificaciones' },
  pwa: { 'pt-BR': 'Aplicativo (PWA)', en: 'App install (PWA)', es: 'Aplicación (PWA)' },
  'web player': { 'pt-BR': 'Web Player', en: 'Web Player', es: 'Web Player' },
  m3u: { 'pt-BR': 'Lista M3U', en: 'M3U playlist', es: 'Lista M3U' },
  'release por office': {
    'pt-BR': 'Versões por Office',
    en: 'Per-office releases',
    es: 'Versiones por Office',
  },
  'bot ops': { 'pt-BR': 'Bot de operações', en: 'Ops bot', es: 'Bot de operaciones' },
  'dual office': { 'pt-BR': 'Dual Office', en: 'Dual Office', es: 'Dual Office' },
  evolution: { 'pt-BR': 'Evolution (WhatsApp)', en: 'Evolution (WhatsApp)', es: 'Evolution (WhatsApp)' },
  'comprar créditos': { 'pt-BR': 'Comprar créditos', en: 'Buy credits', es: 'Comprar créditos' },
  'comprar creditos': { 'pt-BR': 'Comprar créditos', en: 'Buy credits', es: 'Comprar créditos' },
  testes: { 'pt-BR': 'Testes', en: 'Trials', es: 'Pruebas' },
  'pop-ups office': { 'pt-BR': 'Pop-ups do Office', en: 'Office pop-ups', es: 'Pop-ups del Office' },
  'pop-ups mobile': { 'pt-BR': 'Pop-ups no celular', en: 'Mobile pop-ups', es: 'Pop-ups en móvil' },
  'menu gestão': { 'pt-BR': 'Menu Gestão', en: 'Management menu', es: 'Menú Gestión' },
  'header mobile': { 'pt-BR': 'Header no celular', en: 'Mobile header', es: 'Header móvil' },
  'bug report telegram': {
    'pt-BR': 'Relatório de bug no Telegram',
    en: 'Telegram bug report',
    es: 'Informe de bug en Telegram',
  },
  'fix ops loop': {
    'pt-BR': 'Estabilidade Ops / Servidor',
    en: 'Ops / Servidor stability',
    es: 'Estabilidad Ops / Servidor',
  },
};

const DETAIL_REPL = {
  'pt-BR': [
    [/sem r\.content/gi, 'sem carregar o arquivo inteiro'],
    [/ícone PNG \(não HTML\)/gi, 'ícone correto no sistema'],
    [/feedback teste/gi, 'confirmação ao testar o aviso'],
    [/botão Instalar PWA/gi, 'botão para instalar o aplicativo'],
    [/no header\/painel/gi, 'no cabeçalho e no painel de avisos'],
    [/sonda Range/gi, 'verificação rápida do stream'],
    [/VOD streaming/gi, 'filmes e séries em streaming'],
    [/proxy HTTPS movie\/series/gi, 'proxy seguro para filmes e séries'],
    [/pop-up pós-login/gi, 'assistente após o login'],
    [/app instalável \(manifest\/SW\/ícones\)/gi, 'aplicativo instalável com ícones e service worker'],
    [/SW\s*\+\s*pedido no gesto\s*\+\s*teste\s*\+\s*silent:false/gi, 'service worker, pedido de permissão no toque e avisos com som'],
    [/silent:false/gi, 'com som'],
    [/pedido no gesto/gi, 'pedido de permissão no toque'],
    [/stream_dns server_info/gi, 'DNS do stream via informações do servidor'],
    [/fail-fast/gi, 'falha rápida'],
    [/mixed-content/gi, 'conteúdo misto HTTP\/HTTPS'],
    [/empty state centralizado/gi, 'tela vazia centralizada'],
    [/mime inferido/gi, 'tipo de arquivo detectado automaticamente'],
    [/por defeito/gi, 'por padrão'],
    [/prefs ligadas por padrão/gi, 'preferências ligadas por padrão'],
    [/barra limpa \(sem overlap\)/gi, 'barra limpa sem sobreposição'],
    [/sem overlap/gi, 'sem sobreposição'],
    [/largura\/altura dvh/gi, 'largura e altura da tela'],
    [/\bdvh\b/gi, 'viewport'],
    [/safe-area/gi, 'área segura'],
  ],
  en: [
    [/sem r\.content/gi, 'without loading the whole file'],
    [/ícone PNG \(não HTML\)/gi, 'proper system icon'],
    [/feedback teste/gi, 'confirmation when testing alerts'],
    [/botão Instalar PWA/gi, 'button to install the app'],
    [/sonda Range/gi, 'fast stream probe'],
    [/VOD streaming/gi, 'movie/series streaming'],
    [/proxy HTTPS movie\/series/gi, 'secure proxy for movies and series'],
    [/pop-up pós-login/gi, 'post-login assistant'],
  ],
  es: [
    [/sem r\.content/gi, 'sin cargar el archivo completo'],
    [/ícone PNG \(não HTML\)/gi, 'icono correcto en el sistema'],
    [/feedback teste/gi, 'confirmación al probar el aviso'],
    [/botão Instalar PWA/gi, 'botón para instalar la aplicación'],
    [/sonda Range/gi, 'comprobación rápida del stream'],
    [/VOD streaming/gi, 'streaming de películas y series'],
    [/proxy HTTPS movie\/series/gi, 'proxy seguro para películas y series'],
    [/pop-up pós-login/gi, 'asistente tras el inicio de sesión'],
  ],
};

const PT_BR_SPELLING = [
  [/actua(liz)/gi, 'atua$1'],
  [/\bactivo\b/gi, 'ativo'],
  [/\bactiva\b/gi, 'ativa'],
  [/\bactivos\b/gi, 'ativos'],
  [/\bactivas\b/gi, 'ativas'],
  [/\bficheiro\b/gi, 'arquivo'],
  [/\bficheiros\b/gi, 'arquivos'],
  [/\btelemóvel\b/gi, 'celular'],
  [/\btelemóveis\b/gi, 'celulares'],
  [/\bcorrecto\b/gi, 'correto'],
  [/\bcorrecta\b/gi, 'correta'],
  [/\bcorrectos\b/gi, 'corretos'],
  [/\bcorrectas\b/gi, 'corretas'],
  [/\bsecç(ão|ões)\b/gi, 'seç$1'],
  [/\becrã\b/gi, 'tela'],
  [/\becrãs\b/gi, 'telas'],
  [/\butilizador\b/gi, 'usuário'],
  [/\butilizadores\b/gi, 'usuários'],
  [/\bpor defeito\b/gi, 'por padrão'],
];

function toPtBr(text) {
  let s = String(text || '');
  for (const [pat, repl] of PT_BR_SPELLING) s = s.replace(pat, repl);
  return s;
}

export function normalizeReleaseLocale(locale) {
  const low = String(locale || 'pt-BR')
    .trim()
    .toLowerCase()
    .replace('_', '-');
  if (low.startsWith('en')) return 'en';
  if (low.startsWith('es')) return 'es';
  return 'pt-BR';
}

function stripTechnical(detail) {
  let s = String(detail || '').trim();
  s = s.replace(
    /(?:\s*;\s*|\s+)(?:frontend|backend|deploy|whatsapp|ConfigurarOffice)(?:\/|\s|\.)[^.\n]*\.?\s*$/i,
    '',
  );
  s = s.replace(/\s*\[\d+\s*\/\s*\d+\]\.?\s*$/, '');
  return s.replace(/\s+/g, ' ').replace(/^[.;\s]+|[.;\s]+$/g, '');
}

function cleanDetail(detail, locale) {
  let s = stripTechnical(detail);
  const reps = DETAIL_REPL[locale] || DETAIL_REPL['pt-BR'];
  for (const [pat, repl] of reps) s = s.replace(pat, repl);
  if (locale === 'pt-BR') s = toPtBr(s);
  if (s && s[0] === s[0].toLowerCase()) s = s[0].toUpperCase() + s.slice(1);
  if (s && !/[.!?…]$/.test(s)) s += '.';
  return s;
}

function localizeTopic(topic, locale) {
  const key = String(topic || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  const mapped = TOPIC_I18N[key];
  if (mapped) {
    const out = mapped[locale] || mapped['pt-BR'] || topic;
    return locale === 'pt-BR' ? toPtBr(out) : out;
  }
  let t = String(topic || '').trim();
  if (locale === 'pt-BR') t = toPtBr(t);
  return t ? t[0].toUpperCase() + t.slice(1) : t;
}

function categorize(topic, detail) {
  const blob = `${topic} ${detail}`;
  if (/\b(fix|corrige|correção|correcao|bug|falhou|erro|repair|reiniciar|reset)\b/i.test(blob)) {
    return 'fixes';
  }
  if (/\b(deploy|nginx|vps|mysql|dual office|evolution|telegram|ops|infra|env)\b/i.test(blob)
    && !/\b(novo|nova|novidade|botão|pwa|notifica|release|aviso|pop-up|instal)\b/i.test(topic)) {
    return 'infra';
  }
  if (/\b(novo|nova|novidade|botão|pwa|notifica|release|aviso|pop-up|instal)\b/i.test(blob)) {
    return 'features';
  }
  if (/\b(melhor|melhoria|centraliz|proxy|stream|player|ui|menu|mobile|sessão|backup|header)\b/i.test(blob)) {
    return 'improvements';
  }
  if (/\b(deploy|nginx|vps|mysql|dual office|evolution|telegram|ops|infra|env)\b/i.test(blob)) {
    return 'infra';
  }
  return 'other';
}

/** Já formatado pelo backend (tem seções com emoji)? */
export function looksFormattedRelease(text) {
  const s = String(text || '');
  return /^(✨|🚀|🛠️|⚙️|📌)\s/m.test(s) || /Confira o que mudou|Here's what changed|Consulta lo que cambió/i.test(s);
}

/**
 * Resolve o corpo a mostrar: body_i18n[locale] → body formatado → formatação local.
 */
export function resolveReleaseBody(announcement, locale) {
  const loc = normalizeReleaseLocale(locale);
  const i18n = announcement?.body_i18n;
  if (i18n && typeof i18n === 'object') {
    const pick = i18n[loc] || i18n['pt-BR'] || i18n.en || i18n.es;
    if (pick) return loc === 'pt-BR' ? toPtBr(String(pick)) : String(pick);
  }
  const body = String(announcement?.body || '');
  if (!body.trim()) return '';
  if (looksFormattedRelease(body) && loc === 'pt-BR') return toPtBr(body);
  return formatReleaseNotes(body, loc);
}

export function formatReleaseNotes(raw, locale = 'pt-BR') {
  const loc = normalizeReleaseLocale(locale);
  const lines = String(raw || '')
    .split(/\r?\n/)
    .map((ln) => ln.replace(/^[\s\-*•]+/, '').replace(/^\d{4}-\d{2}-\d{2}:\s*/, '').trim())
    .map((ln) => stripTechnical(ln))
    .filter(Boolean);

  if (!lines.length) {
    return (
      {
        'pt-BR': 'Atualização do Office aplicada com melhorias e correções.',
        en: 'Office update applied with improvements and fixes.',
        es: 'Actualización del Office aplicada con mejoras y correcciones.',
      }[loc] || ''
    );
  }

  if (looksFormattedRelease(raw) && lines.some((l) => l.startsWith('• '))) {
    const relabeled = relabelFormatted(raw, loc);
    return loc === 'pt-BR' ? toPtBr(relabeled) : relabeled;
  }

  const buckets = {
    features: [],
    improvements: [],
    fixes: [],
    infra: [],
    other: [],
  };

  for (const line of lines) {
    let topic = line;
    let detail = '';
    if (line.includes('—')) {
      const i = line.indexOf('—');
      topic = line.slice(0, i).trim();
      detail = line.slice(i + 1).trim();
    } else if (line.includes(' - ')) {
      const i = line.indexOf(' - ');
      topic = line.slice(0, i).trim();
      detail = line.slice(i + 3).trim();
    }
    topic = stripTechnical(topic.replace(/[.:]+$/, '').trim());
    const detailPt = detail ? cleanDetail(detail, 'pt-BR') : '';
    const section = categorize(topic, detailPt || topic);
    const topicL = localizeTopic(topic, loc);
    const detailL = detailPt ? cleanDetail(detailPt.replace(/\.$/, ''), loc).replace(/\.$/, '') : '';
    buckets[section].push(detailL ? `${topicL} — ${detailL}.` : topicL);
  }

  const order = ['features', 'improvements', 'fixes', 'infra', 'other'];
  const meta = SECTION_META[loc] || SECTION_META['pt-BR'];
  const out = [INTRO[loc], ''];
  for (const sid of order) {
    if (!buckets[sid].length) continue;
    const [emoji, label] = meta[sid];
    out.push(`${emoji} ${label}`);
    for (const it of buckets[sid]) out.push(`• ${it}`);
    out.push('');
  }
  while (out.length && out[out.length - 1] === '') out.pop();
  const text = out.join('\n');
  return loc === 'pt-BR' ? toPtBr(text) : text;
}

function relabelFormatted(raw, locale) {
  const loc = normalizeReleaseLocale(locale);
  const meta = SECTION_META[loc] || SECTION_META['pt-BR'];
  const map = {
    Novidades: meta.features,
    "What's new": meta.features,
    Novedades: meta.features,
    Melhorias: meta.improvements,
    Improvements: meta.improvements,
    Mejoras: meta.improvements,
    Correções: meta.fixes,
    Fixes: meta.fixes,
    Correcciones: meta.fixes,
    'Plataforma e infraestrutura': meta.infra,
    'Platform & infrastructure': meta.infra,
    'Plataforma e infraestructura': meta.infra,
    'Outras atualizações': meta.other,
    'Outras actualizações': meta.other,
    'Other updates': meta.other,
    'Otras actualizaciones': meta.other,
  };
  return String(raw || '')
    .split(/\r?\n/)
    .map((ln) => {
      const m = ln.match(/^(✨|🚀|🛠️|⚙️|📌)\s+(.+)$/);
      if (!m) {
        if (/Confira o que mudou|Here's what changed|Consulta lo que cambió/i.test(ln)) {
          return INTRO[loc];
        }
        return ln;
      }
      const hit = map[m[2].trim()];
      if (hit) return `${hit[0]} ${hit[1]}`;
      return ln;
    })
    .join('\n');
}

/**
 * Partes para renderização rica no pop-up.
 * @param {string} text
 * @param {string} locale
 * @returns {{ intro: string, sections: { emoji: string, title: string, items: string[] }[] }}
 */
export function parseReleaseForDisplay(text, locale = 'pt-BR') {
  const loc = normalizeReleaseLocale(locale);
  let formatted = looksFormattedRelease(text) ? relabelFormatted(text, loc) : formatReleaseNotes(text, loc);
  if (loc === 'pt-BR') formatted = toPtBr(formatted);
  const lines = formatted.split(/\r?\n/);
  let intro = '';
  const sections = [];
  let current = null;
  for (const ln of lines) {
    const header = ln.match(/^(✨|🚀|🛠️|⚙️|📌)\s+(.+)$/);
    if (header) {
      current = { emoji: header[1], title: header[2].trim(), items: [] };
      sections.push(current);
      continue;
    }
    if (ln.startsWith('• ') || ln.startsWith('- ')) {
      if (!current) {
        current = { emoji: '📌', title: (SECTION_META[loc] || SECTION_META['pt-BR']).other[1], items: [] };
        sections.push(current);
      }
      current.items.push(ln.replace(/^[\s•\-]+/, '').trim());
      continue;
    }
    if (!sections.length && ln.trim()) {
      intro = ln.trim();
    }
  }
  return { intro: intro || INTRO[loc], sections: sections.filter((s) => s.items.length) };
}
